import { render, staticRenderFns } from "./artists-search-list.vue?vue&type=template&id=2229ae1b"
import script from "./artists-search-list.vue?vue&type=script&lang=js"
export * from "./artists-search-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports